/**
 * IS Reveal — scroll-triggered fade-up animations
 * Targets elements with class .is-reveal, adds .is-visible on entry
 * Respects prefers-reduced-motion
 */
(function () {
  'use strict';

  if (!window.IntersectionObserver) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.is-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.10,
    rootMargin: '0px 0px -32px 0px'
  });

  function observe() {
    document.querySelectorAll('.is-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Shopify theme editor re-renders
  document.addEventListener('shopify:section:load', observe);
})();
